export const formatVKDate = (date: string) => {
    const dateParts = date.split('.');

    // format YYYY-mm-dd
    return dateParts.length === 3
        ? `${dateParts[2]}-${dateParts[1].padStart(2, '0')}-${dateParts[0].padStart(2, '0')}`
        : date;
};
